module.exports = __webpack_public_path__ + "img/BB.732c2ef1.jpg";